import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import Login from './Pages/Login';
import ClinetMaster from './Master/ClinetMaster';
import CompanyBankingDetails from './Master/CompanyBankingDetails';
import SessionMaster from './Master/SessionMaster';
import InvoiceGenerator from './Pages/InvoiceGenerator';
import Sidebar from './Pages/Sidebar';
import { masterPageShell } from './Pages/MasterCssClass';
import AKYBilling from './Pages/AKYBilling';

const App = () => {
  // Initialize token and username from sessionStorage to prevent mobile refresh logouts
  const [token, setToken] = useState(() => sessionStorage.getItem('token') || '');
  const [username, setUsername] = useState(() => sessionStorage.getItem('username') || '');
  const [activeTab, setActiveTab] = useState('invoice');

  const handleLoginSuccess = (newToken, loggedInUsername) => {
    sessionStorage.setItem('token', newToken);
    sessionStorage.setItem('username', loggedInUsername || '');
    setToken(newToken);
    setUsername(loggedInUsername || '');
  };

  const handleLogout = () => {
    sessionStorage.clear();
    setToken('');
    setUsername('');
  };

  return (
    <div className={masterPageShell}>
      {/* Wrapped in print:hidden so toast messages never appear on printed/downloaded PDFs */}
      <div className="print:hidden">
        <Toaster
          position="top-center"
          reverseOrder={false}
          toastOptions={{
            style: {
              fontWeight: 600,
              fontSize: '11px',
              textTransform: 'uppercase',
              fontFamily: 'sans-serif',
              maxWidth: '320px',
              width: '100%',
              borderRadius: '8px',
              padding: '8px 12px',
            },
            success: {
              style: { background: '#f0fdf4', color: '#358156', border: '1px solid #358156' },
            },
            error: {
              style: { background: '#fef2f2', color: '#FF6B6B', border: '1px solid #FF6B6B' },
            },
          }}
        />
      </div>

      <Routes>
        {!token ? (
          <>
            <Route path="/login" element={<Login setToken={handleLoginSuccess} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        ) : username.toLowerCase() === 'anandi' ? (
          /* ANANDI USER VIEW: DIRECTLY OPEN AKYBILLING, NO SIDEBAR */
          <>
            <Route 
              path="/*" 
              element={
                <div className="h-screen overflow-y-auto p-2 bg-[#FAFAFC]">
                  <AKYBilling token={token} handleLogout={handleLogout} isAnandiUser={true} />
                </div>
              } 
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          /* DEFAULT USER VIEW (SIXFOX): FULL DASHBOARD WITH SIDEBAR */
          <>
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route
              path="/*"
              element={
                <div className="flex flex-col md:flex-row h-screen">
                  <Sidebar 
                    activeTab={activeTab} 
                    setActiveTab={setActiveTab} 
                    handleLogout={handleLogout} 
                  />
                  <main className="flex-1 overflow-y-auto p-2 bg-[#FAFAFC]">
                    <Routes>
                      <Route path="/" element={<InvoiceGenerator token={token} />} />
                      <Route path="/invoice" element={<InvoiceGenerator token={token} />} />
                      <Route path="/client" element={<ClinetMaster token={token} />} />
                      <Route path="/companyBankingDetails" element={<CompanyBankingDetails token={token} />} />
                      <Route path="/sessions" element={<SessionMaster token={token} />} />
                      <Route path="/aky-billing" element={<AKYBilling token={token} />} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </main>
                </div>
              }
            />
          </>
        )}
      </Routes>
    </div>
  );
};

export default App;